(() => {
  if (window.__madeInPredictiveTrigger) return;
  window.__madeInPredictiveTrigger = true;

  const RECENT_KEY = 'madein_recent_searches_v1';
  const openSearch = (event) => {
    const trigger = event.target instanceof Element
      ? event.target.closest('.mi-header-search__input, .mi-header-search__submit, .made-mobile-dock a[href*="/search"]')
      : null;
    if (!trigger) return;

    const component = document.querySelector('#search-modal');
    if (!component || typeof component.showDialog !== 'function') return;

    event.preventDefault();
    component.showDialog();

    requestAnimationFrame(() => {
      const input = component.querySelector('.search-input');
      const headerValue = trigger.closest('.mi-header-search')?.querySelector('.mi-header-search__input')?.value?.trim();
      if (!input) return;
      input.focus();
      if (headerValue) {
        input.value = headerValue;
        input.dispatchEvent(new InputEvent('input', {bubbles:true, inputType:'insertText', data:headerValue}));
      }
    });
  };

  const saveRecentSearch = (form) => {
    const value = form.querySelector('input[name="q"]')?.value?.trim();
    if (!value) return;
    let recent = [];
    try { recent = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (_) {}
    recent = [value, ...(Array.isArray(recent) ? recent : []).filter((item) => item !== value)].slice(0, 6);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(recent)); } catch (_) {}
  };

  document.addEventListener('click', openSearch);
  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('.mi-header-search');
    if (form) openSearch({target: form.querySelector('.mi-header-search__submit'), preventDefault: () => event.preventDefault()});
    if (event.target.closest?.('.predictive-search-form')) saveRecentSearch(event.target);
  });
  document.addEventListener('keydown', (event) => {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault(); document.querySelector('#search-modal')?.showDialog();
    }
  });
  document.addEventListener('input', (event) => {
    if (!event.target.matches?.('#search-modal .search-input')) return;
    const reset = document.querySelector('#search-modal .predictive-search__reset-button');
    if (reset) reset.hidden = !event.target.value.trim();
  });
})();
